import React, { useState, useEffect } from "react";
// import pdf1 from "../images/RealizedGL-Template.pdf"
import DownloadIcon from "../images/download.png"
import ToggleArrow from '../images/toggle-arrow.png'
import callingAPI from "../service"
import { useLocation } from "react-router-dom";
import loadingImage from '../images/login-shape.png'
import moment from 'moment';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Header from "../layout/header";
import HeaderProfile from "../layout/header-profile";
import { setReportData } from "../redux/reducers/reportSlice";
import { setDashboardData } from "../redux/reducers/dashboardSlice";
export default function GainLoss() {
    const dispatch = useDispatch();
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const [toggleTd, setToggleTd] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const [toggelTdOne, setToggleTdOne] = useState(1)
    const clientId = dashboardDetails.clientid
    const userId = dashboardDetails.userId
    const [loaderFlag, setLoaderFlag] = useState(false)
    const location = useLocation();
    const [realizedSummery, setRealizedSummery] = useState([])
    const [realizedDetails, setRealizedDetails] = useState([])
    const [realizedSummeryTotal, setRealizedSummeryTotal] = useState([])
    const refreshToken = dashboardDetails.refreshToken;


    var userLogId = ""
    useEffect(() => {
        dispatch(
            setDashboardData({
                moduleId: 9,
                userlogId: ""
            })
        );
        handleUserLog()
        return () => {
            handleUserLog();
        };
    }, []);

    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 9,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 9,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    const toggleTableTd = (index) => {
        if (isMobile) {
            setToggleTd(toggleTd === index ? null : index);
        }
    };

    useEffect(() => {

        if (location.state) {
            // realizedList();
        }
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [location.state]);

    const toggleTableTdOne = (index) => {
        if (isMobile) {
            setToggleTdOne(toggelTdOne === index ? null : index)
        }
    }
    useEffect(() => {
        realizedList();

    }, [location])

    const realizedList = () => {
        const transFrom = dashboardDetails.fromDate ? new Date(dashboardDetails.fromDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]
        const transTo = dashboardDetails.toDate ? new Date(dashboardDetails.toDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]

        const postData = {
            "userId": userId,
            "fromDate": transFrom,
            "toDate": transTo,
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/realized", 'post')
            .then((response) => {
                const { data } = response;
                console.log("🚀 ~ .then ~ data: realizedList", data)
                if (data.statusCode === 200) {
                    dispatch(setReportData({
                        realized: data.data
                    }))
                    setRealizedSummery(data.data.realizedSummery || []);
                    setRealizedSummeryTotal(data.data.total || []);
                    setRealizedDetails(data.data.realizedDetails || []);

                    setLoaderFlag(true)
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };

    const totalAEDBalance = parseFloat(realizedSummeryTotal);

    return (
        <>
            <div className="top-outer">
                <div className="heading-outer">
                    <Header />
                    <HeaderProfile />
                </div>
            </div>
            {loaderFlag ?
                <div className="reports-table">
                    {/* <div className="dwnlod-btn-right">
                <a target="_blank" href="/realizedGL-template" className=""><img src={DownloadIcon} alt="" width={32} /></a>
            </div> */}
                    <h3 className="reports-mainHead">Realized Gain / Loss Summary
                        <span className="date-table-head">({moment(dashboardDetails.reportClickFromDate).format('DD/MM/yyyy')} - {moment(dashboardDetails.reportClickToDate).format('DD/MM/yyyy')})</span></h3>
                    <div className="row">
                        <div className="col-xl-8 mx-auto">
                            <div className="table-responsive">
                                <table className="table  table-change mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%', minWidth: '260px' }}>Exchange Desc</th>
                                            <th style={{ width: '20%', minWidth: '165px' }}>Currency Desc</th>
                                            <th style={{ width: '20%', minWidth: '165px' }}>Realized G/L (Tran Curr)</th>
                                            <th style={{ width: '20%', minWidth: '165px' }}>Realized G/L (AED)</th>
                                        </tr>
                                    </thead>
                                    {realizedSummery?.length > 0 ?
                                        <tbody>
                                            {(isMobile && toggleTd === 1) || (!isMobile) ? (
                                                <>

                                                    <>
                                                        {realizedSummery && realizedSummery.map((item, index) => (
                                                            <tr>
                                                                <td className="td-colors table-split-head moble-thead-change">{item.exchange_Desc}
                                                                    <div className="toggle-table" onClick={() => toggleTableTd(1)}>
                                                                        <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                                    </div>
                                                                </td>

                                                                <>
                                                                    <td className="td-colors table-split-head moble-thead-change">{item.currency_Desc}
                                                                        <div className="toggle-table" onClick={() => toggleTableTd(1)}>
                                                                            <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                                        </div>
                                                                    </td>
                                                                    {/* <td className="text-end  table-split-div">
                                                                        <span className="mobile-td-head">Currency Desc</span>
                                                                        <span style={{ color: Number(item.currency_Desc) < 0 ? '#E43740' : 'black' }}>
                                                                            {Number(item.currency_Desc) < 0
                                                                                ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.currency_Desc)) || 0)})`
                                                                                : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.currency_Desc) || 0)}
                                                                        </span>
                                                                    </td> */}
                                                                    <td className="text-end  table-split-div">
                                                                        <span className="mobile-td-head">Realized G/L (Tran Curr)</span>
                                                                        <span style={{ color: Number(item.Realized_GL_Tran_Curr) < 0 ? '#E43740' : 'black' }}>
                                                                            {Number(item.Realized_GL_Tran_Curr) < 0
                                                                                ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.Realized_GL_Tran_Curr)) || 0)})`
                                                                                : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.Realized_GL_Tran_Curr) || 0)}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-end  table-split-div">
                                                                        <span className="mobile-td-head">Realized G/L (AED)</span>
                                                                        <span style={{ color: Number(item.Realized_GL_AED) < 0 ? '#E43740' : 'black' }}>
                                                                            {Number(item.Realized_GL_AED) < 0
                                                                                ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.Realized_GL_AED)) || 0)})`
                                                                                : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.Realized_GL_AED) || 0)}
                                                                        </span>
                                                                    </td>
                                                                </>

                                                            </tr>
                                                        ))}
                                                    </>
                                                </>
                                            ) : null}
                                            {/* <tr>
                                    <td className="td-colors table-split-head moble-thead-change">Abu Dhabi Securities Exchange
                                        <div className="toggle-table" onClick={() => toggleTableTd(2)}>
                                            <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                        </div>
                                    </td>
                                    {(isMobile && toggleTd === 2) || (!isMobile) ? (
                                        <>
                                            <td className="table-split-div">
                                                <span className="mobile-td-head">Currency Desc</span>
                                                UAE Dirham</td>
                                            <td className="text-end table-split-div">
                                                <span className="mobile-td-head">Realized G/L (Tran Curr)</span>
                                                998.260</td>
                                            <td className="text-end table-split-div">
                                                <span className="mobile-td-head">Realized G/L (AED)</span>
                                                998.260 </td>
                                        </>
                                    ) : null}
                                </tr> */}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                                <td colSpan="4" style={{ textAlign: "center", padding: "30px 0", width: "100%" }}>
                                                    No Data
                                                </td>
                                            </tr>
                                        </tbody>}
                                    <tfoot>
                                        {realizedSummery?.length > 0 &&
                                            <tr>
                                                <td className="bg-tr-td invisible-classes"></td>
                                                <td className="bg-tr-td invisible-classes"></td>
                                                <td className="tfoot-color bottom-left-radius invisible-classes">Total</td>
                                                <td className="tfoot-color text-end bottom-right-radius  table-split-div">
                                                    <span className="mobile-td-head">Total Balance</span>
                                                    <span style={{ color: Number(totalAEDBalance) < 0 ? '#E43740' : 'black' }}>
                                                        {Number(totalAEDBalance) < 0
                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalAEDBalance)) || 0)})`
                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalAEDBalance) || 0)}
                                                    </span>
                                                </td>
                                            </tr>}
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table  table-change">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '50px', maxWidth: '50px' }}>Tran Date</th>
                                    <th style={{ minWidth: '70px', maxWidth: '70px' }}>Settlement Date</th>
                                    <th style={{ minWidth: '55px', maxWidth: '55px' }}>Buy/Sell Flag</th>
                                    <th style={{ minWidth: '65px', maxWidth: '65px' }}>Long/Short Flag</th>
                                    <th style={{ minWidth: '50px', maxWidth: '50px' }}>Shares</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Avg Price</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Amount</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Net</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Realized G/L</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Balance Shares</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Cost Price</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Cost Value</th>
                                </tr>
                            </thead>
                            {realizedDetails?.length > 0 ?
                                <tbody>

                                    <>
                                        {realizedDetails.map((item, index) => (
                                            <>
                                                <tr>
                                                    <td colSpan={12} className="p-0 border-0 td-full">
                                                        <table className="table mb-0 table-change">
                                                            <tbody>
                                                                <tr className="td-colors-tr">
                                                                    <td colSpan={12} className="td-colors bg-white border-0 table-split-head  moble-thead-change">{item.stockname}
                                                                        <div className="toggle-table"
                                                                            onClick={() => toggleTableTdOne(1)}
                                                                        >
                                                                            <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody className="table-body-border">

                                                                {(isMobile && toggelTdOne === 1) || (!isMobile) ? (
                                                                    <>
                                                                        {item.records.map((innnerItem, innerIndex) =>
                                                                            <tr>
                                                                                <td className=" table-split-div" style={{ minWidth: '50px', maxWidth: '50px' }}>
                                                                                    <span className="mobile-td-head ">Tran Date</span>
                                                                                    {innnerItem.tranDate}</td>
                                                                                <td className=" table-split-div" style={{ minWidth: '70px', maxWidth: '70px' }}>
                                                                                    <span className="mobile-td-head">Settlement Date</span>
                                                                                    {innnerItem.settlementDate}</td>
                                                                                <td className=" table-split-div" style={{ minWidth: '55px', maxWidth: '55px' }}>
                                                                                    <span className="mobile-td-head">Buy/Sell Flag</span>
                                                                                    {innnerItem.buySellFlag}</td>
                                                                                <td className=" table-split-div" style={{ minWidth: '65px', maxWidth: '65px' }}>
                                                                                    <span className="mobile-td-head">Long/Short Flag</span>
                                                                                    {innnerItem.longShortFlag}</td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '50px', maxWidth: '50px' }}>
                                                                                    <span className="mobile-td-head">Shares</span>
                                                                                    <span style={{ color: Number(innnerItem.shares) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.shares) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.shares)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.shares) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Avg Price</span>
                                                                                    <span style={{ color: Number(innnerItem.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.avgPrice) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(innnerItem.avgPrice)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(innnerItem.avgPrice) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Amount</span>
                                                                                    <span style={{ color: Number(innnerItem.amount) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.amount) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.amount)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.amount) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Net</span>
                                                                                    <span style={{ color: Number(innnerItem.net) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.net) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.net)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.net) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Realized G/L</span>
                                                                                    <span style={{ color: Number(innnerItem.realizedGL) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.realizedGL) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.realizedGL)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.realizedGL) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Balance Shares</span>
                                                                                    <span style={{ color: Number(innnerItem.balanceShares) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.balanceShares) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.balanceShares)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.balanceShares) || 0)}
                                                                                    </span>
                                                                                </td>

                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Cost Price</span>
                                                                                    <span style={{ color: Number(innnerItem.costPrice) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.costPrice) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(innnerItem.costPrice)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(innnerItem.costPrice) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                    <span className="mobile-td-head">Cost Value</span>
                                                                                    <span style={{ color: Number(innnerItem.costValue) < 0 ? '#E43740' : 'black' }}>
                                                                                        {Number(innnerItem.costValue) < 0
                                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.costValue)) || 0)})`
                                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.costValue) || 0)}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </>

                                                                ) : null}

                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </>))}
                                    </>

                                </tbody>
                                :
                                <tbody>
                                    <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "50px 0", width: "100%" }}>
                                            No Data
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div> :
                <div className="d-flex justify-content-center align-items-center loading-container">
                    <div className="spinner-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <img src={loadingImage} alt="Loading..." className="loading-image" />
                    </div>
                </div>
            }
        </>
    )
}